/**
 * Поле ввода суммы с разделением разрядов.
 *
 * «151974,93» читается заметно хуже, чем «151 974,93», а ошибка на разряд в
 * деньгах стоит дорого. Разделитель — неразрывный пробел, тот же, что в выводе,
 * и parseAmountInput отбрасывает его наравне с прочими знаками.
 */
import { formatAmountInput } from './store.js';

export function AmountInput({ value, onChange, placeholder, label, className }: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  label?: string;
  className?: string;
}) {
  return (
    <input
      value={value}
      inputMode="decimal"
      {...(placeholder ? { placeholder } : {})}
      {...(label ? { 'aria-label': label } : {})}
      {...(className ? { className } : {})}
      onChange={(e) => {
        const el = e.target;
        // Переформатирование уводит курсор в конец, поэтому разряды
        // расставляются только при вводе с конца — а это обычный случай. При
        // правке внутри строки значение остаётся как набрано и приведётся
        // к разрядам при следующем вводе с конца.
        const atEnd = el.selectionStart === null || el.selectionStart >= el.value.length;
        onChange(atEnd ? formatAmountInput(el.value) : el.value.replace(/[^\d.,  ]/g, ''));
      }}
    />
  );
}
